import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IPageResource, PageStatus } from "../types";

export type IPageUpdateMutationParameters = {
    data: {
        title?: string;
        content?: string;
        rank?: number;
        status?: PageStatus;
    };
    page: RelationalValue<IPageResource>;
};

export type IPageUpdateMutationResult = IPageResource;

export const pageUpdateMutation: IApiMutationFunction<IPageUpdateMutationParameters> = ({
    page,
    data: { title, content, rank, status },
}) => {
    return {
        method: "PUT",
        url: `/pages/${mapRelationalValue(page)}`,
        data: {
            title,
            content,
            rank,
            status,
        },
    };
};

export const usePageUpdateMutation = createApiMutationHook<IPageUpdateMutationParameters, IPageUpdateMutationResult>(
    pageUpdateMutation,
);
